import React from 'react';
import { Link } from 'react-router-dom';
import ContractRow from './ui/ContractRow';
import { CONTRACTS, LINKS, SOCIALS } from '../data/site';

const Footer = () => (
  <footer className="mt-8 border-t-[3px] border-ink pb-[110px] pt-5 text-[13px] sm:pb-10 lg:mt-16 lg:pt-8 lg:text-sm">
    <div className="wrap">
      <div className="mb-4 grid gap-2.5 lg:grid-cols-2 lg:gap-3.5">
        <ContractRow chain={CONTRACTS.arbitrum} />
        <ContractRow chain={CONTRACTS.solana} />
      </div>
      <div className="mb-3.5 rounded-2xl border-[3px] border-ink bg-paper px-3.5 py-3 shadow-hard lg:px-5 lg:py-4">
        <strong>Heads up:</strong> $BOOP is a memecoin with no intrinsic value or expectation of financial return. Nothing on this site is
        financial advice. Do your own research and boop responsibly.
      </div>
      <div className="flex flex-col items-center gap-2 text-center font-medium sm:flex-row sm:justify-between sm:text-left">
        <p>BOOP THE COIN · Everyone deserves a boop.</p>
        <p className="flex flex-wrap justify-center gap-x-3 gap-y-1">
          <Link to="/buy" className="underline">
            Buy
          </Link>
          <Link to="/memefi" className="underline">
            MemeFi
          </Link>
          <Link to="/games" className="underline">
            Games
          </Link>
          {SOCIALS.map((s) => (
            <a key={s.href} href={s.href} target="_blank" rel="noopener noreferrer" className="underline">
              {s.label === 'X / Twitter' ? 'X' : s.label}
            </a>
          ))}
          <a href={LINKS.coingecko} target="_blank" rel="noopener noreferrer" className="underline">
            CoinGecko
          </a>
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
